import { Compiler } from 'repl-sdk';
import { CACHE } from './compile/compile.js';
import { setup } from './setup.js';

function clearCompileCache() {
  CACHE.clear();
}
function clearCache(hooks) {
  hooks.beforeEach(function () {
    Compiler.clearCache();
  });
  hooks.afterEach(function () {
    Compiler.clearCache();
  });
}
function setupCompiler(hooks, options) {
  hooks.beforeEach(function () {
    Compiler.clearCache();
    if (options?.clearCache) {
      clearCompileCache();
    }
    setup(this, options);
  });
  hooks.afterEach(function () {
    Compiler.clearCache();
    if (options?.clearCache) {
      clearCompileCache();
    }
  });
}

export { clearCache, clearCompileCache, setupCompiler };
//# sourceMappingURL=test-support.js.map
